// カラーパレット定義 (デフォルトをダークモードに設定)
export const colors = {
  // Primary
  primary: '#FF0000', // YouTube Red
  primaryLight: '#FF4D4D',
  primaryDark: '#CC0000',

  // Secondary
  secondary: '#FFFFFF',
  secondaryLight: '#AAAAAA',
  secondaryDark: '#FFFFFF',

  // Background
  background: '#000000',
  backgroundSecondary: '#0F0F0F',
  backgroundTertiary: '#272727',
  card: '#0F0F0F',

  // Text
  text: '#FFFFFF',
  textSecondary: '#AAAAAA',
  textTertiary: '#717171',
  textInverse: '#000000',

  // Interactive
  like: '#FF0000',
  repost: '#2BA640',
  reply: '#3EA6FF',
  link: '#3EA6FF',

  // Status
  success: '#2BA640',
  warning: '#FBC02D',
  error: '#FF4E45',
  info: '#3EA6FF',

  // Border
  border: '#272727',
  borderLight: '#3F3F3F',
  borderDark: '#717171',

  // Other
  overlay: 'rgba(0, 0, 0, 0.8)',
  shadow: 'rgba(0, 0, 0, 0.5)',
} as const;

// ダークモードカラー (YouTube風の真の黒)
export const darkColors = colors;

export type ColorScheme = typeof colors;
